import { Component } from '@angular/core';

@Component({
  selector: 'app-reported-bug',
  imports: [],
  templateUrl: './reported-bug.component.html',
  styleUrl: './reported-bug.component.css',
})
export class ReportedBugComponent {

}
